import { useState, useEffect } from "react";
import "../assets/CPResource.css";

import rp from '../assets/imgs/RiverParadise/river-paradise.png';
import rp2 from '../assets/imgs/RiverParadise/river-paradise2.png';
import rp3 from '../assets/imgs/RiverParadise/rp3.png';
import rp4 from '../assets/imgs/RiverParadise/rp4.png';

export default function CPResourcePage() {
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ name: "", mobile: "" });
    const [isUnlocked, setIsUnlocked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if (isUnlocked) {
            setTimeout(() => setShowPopup(true), 1000);
        }
    }, [isUnlocked]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (!formData.name || !formData.mobile) {
            return alert("Please fill all fields");
        }

        if (!/^[0-9]{10}$/.test(formData.mobile)) {
            return alert("Enter valid 10 digit mobile number");
        }

        setLoading(true);

        try {
            const res = await fetch(
                "https://samriddhidevelopers.in/backend/save_cp.php",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                }
            );

            const data = await res.json();

            if (data.status === "success") {
                setIsUnlocked(true);
            } else {
                alert(data.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="container">

            {/* HERO */}
            {!isUnlocked && (
                <div className="hero">
                    <div className="overlay">
                        <h1>River Paradise</h1>
                        <p>Where Nature Meets Luxury Investment</p>

                        {!showForm ? (
                            <button className="btn-primary" onClick={() => setShowForm(true)}>
                                Access CP Materials
                            </button>
                        ) : (
                            <div className="form-box">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Name"
                                    className="input"
                                    onChange={handleChange}
                                />
                                <input
                                    type="text"
                                    name="mobile"
                                    placeholder="Mobile Number"
                                    className="input"
                                    onChange={handleChange}
                                />
                                <button
                                    className="btn-secondary"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Please wait..." : "Unlock Access"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* IMAGE STRIP */}
            {!isUnlocked && (
                <div className="image-strip">
                    <img src={rp} alt="" />
                    <img src={rp2} alt="" />
                    <img src={rp3} alt="" />
                    <img src={rp4} alt="" />
                </div>
            )}

            {/* DASHBOARD */}
            {isUnlocked && (
                <div className="dashboard">
                    <div className="dashboard-inner">
                        <h1 className="dashboard-title">
                            River Paradise Marketing Material
                        </h1>

                        <p className="dashboard-sub">
                            Everything you need to close deals is below
                        </p>

                        <div className="grid">
                            <a href="https://drive.google.com/drive/folders/1ub1O0ROERsfcoTovz1YQ-PbnSrkBzRXP?usp=drive_link" target="_blank" className="card">📘 Brochure</a>
                            <a href="https://drive.google.com/drive/folders/1_8vlz3Udin_n-3QxSj8J7SUbkVhYUX8M?usp=drive_link" target="_blank" className="card">🗺 Layout</a>
                            <a href="https://drive.google.com/drive/folders/1TseU1IPYUVfA0ndQpZsqH629YZYmKMY3?usp=drive_link" target="_blank" className="card">🎥 Videos</a>
                            <a href="https://drive.google.com/drive/folders/1PXcEQVrvaUB3xFAEVEQR89lwmqcKTAHr?usp=drive_link" target="_blank" className="card">📄 Price Sheet</a>
                            <a href="https://drive.google.com/drive/folders/1EchSJkWWF2S-MiD5XAW1G-fSAreo7raZ?usp=drive_link" target="_blank" className="card">📢 Creatives</a>

                        </div>
                    </div>
                </div>
            )}

            {/* POPUP */}
            {showPopup && (
                <div className="popup">
                    <p>Need help closing a deal?</p>
                    <a href="tel:9766150099">Contact Sales Team</a>
                </div>
            )}
        </div>
    );
}